import React from 'react';
import { PAYMENT_TYPE_LABELS } from '../../../constants';
import { toDateTimeLocalValue } from './OrderDetailsUtils';
import { useLanguage } from '../../../i18n/LanguageContext';

const OrderDetailsPaymentForm = ({
  isEditMode,
  customerId,
  orders,
  isMontajci,
  isPaymentCompleted,
  newPaymentType,
  setNewPaymentType,
  newPaymentAmount,
  setNewPaymentAmount,
  newPaymentDate,
  setNewPaymentDate,
  isAddingPayment,
  handleAddPayment,
  isLoading
}) => {
  const { t } = useLanguage();

  if (!(isEditMode && customerId && !customerId.startsWith('temp_') && orders.length > 0 && !isMontajci && !isPaymentCompleted)) {
    return null;
  }

  return (
    <div className="payment-add-section">
      <h5><i className="fas fa-plus-circle"></i> {t('orderSummary.newPayment', 'Yeni Ödeme Ekle')}</h5>
      <div className="payment-add-form">
        <div className="payment-add-row">
          <div className="payment-type-select">
            <label>{t('orderSummary.paymentType', 'Ödeme Tipi:')}</label>
            <select
              value={newPaymentType}
              onChange={(e) => setNewPaymentType(e.target.value)}
              disabled={isAddingPayment}
            >
              {Object.entries(PAYMENT_TYPE_LABELS).map(([key, label]) => (
                <option key={key} value={key}>{t('paymentType.' + key, label)}</option>
              ))}
            </select>
          </div>
          <div className="payment-amount-input">
            <label>{t('orderSummary.amount', 'Tutar (€):')}</label>
            <input
              type="number"
              step="0.01"
              min="0"
              value={newPaymentAmount}
              onChange={(e) => setNewPaymentAmount(e.target.value)}
              placeholder="0.00"
              disabled={isAddingPayment}
            />
          </div>
          <div className="payment-amount-input">
            <label>{t('orderSummary.paymentDate', 'Ödeme Tarihi:')}</label>
            <input
              type="datetime-local"
              value={newPaymentDate}
              max={toDateTimeLocalValue()}
              onChange={(e) => setNewPaymentDate(e.target.value)}
              disabled={isAddingPayment}
            />
          </div>
          <button
            type="button"
            onClick={handleAddPayment}
            className="payment-add-btn"
            disabled={isAddingPayment || isLoading || !newPaymentAmount}
          >
            {isAddingPayment ? (
              <i className="fas fa-spinner fa-spin"></i>
            ) : (
              <><i className="fas fa-plus"></i> {t('orderSummary.add', 'Ekle')}</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsPaymentForm;
